/**
 * @file Hook that tells us which compose type is
 */
import { SEARCH_PARAM__COMPOSE_TYPE } from '../../../constants/routing/searchParams';
import { ComposeTypeParam } from '../../../models/pageParams';

import useSearchParams from './useSearchParams';

/**
 * Hook that tells us which compose type is open
 * based on the url
 *
 * @returns Type of compose (post or task) or null if none
 */
const useComposeType = (): ComposeTypeParam | null => {
  const query = useSearchParams();

  const composeType = query.get(SEARCH_PARAM__COMPOSE_TYPE);

  if (composeType === null) {
    return null;
  }

  return composeType as ComposeTypeParam;
};

export default useComposeType;
